var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"item",class:_vm.classByValue,attrs:{"title":_vm.title}},[_c('input',{attrs:{"type":"button"},on:{"click":_vm.onClick}}),_c('span',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }